import React from 'react';

import { Box, Link, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

export default function ToursIdsFormatter({ row }: { row: LereToursPricingSuggestion }) {
  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1, wordBreak: 'break-all' }}>
      <Typography variant="body2" fontWeight="bold">
        Offer ID:
      </Typography>
      <Typography variant="body2">{row.offer_bk || '—'}</Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Salesforce ID:
      </Typography>
      <Typography variant="body2">{row.offer_salesforce_bk || '—'}</Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Departure Name:
      </Typography>
      <Typography variant="body2">{row.departure_name || '—'}</Typography>
      {row.cloned_from_departure_id && (
        <>
          <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
            Cloned From:
          </Typography>
          <Typography variant="body2">
            <Link
              href={`https://luxgroup.lightning.force.com/lightning/r/Season_Depatures__c/${row.cloned_from_departure_id}/view`}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {row.cloned_from_departure_name ?? row.cloned_from_departure_id}
            </Link>
          </Typography>
        </>
      )}
    </Box>
  );
}
